export const FETCH_COURSES = "FETCH_COURSES";
export const SET_MESSAGES = "SET_MESSAGES";
export const CHANGE_MESSAGE_LAST_VISITED = "CHANGE_MESSAGE_LAST_VISITED";
export const LOGOUT_PWA = "LOGOUT_PWA";
